import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import ProductCard from "@/components/store/ProductCard";
import EmptyCatalog from "@/components/store/EmptyCatalog";

export default function Shop() {
  const { settings } = useStore();
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const sort = params.get("sort") || "newest";
  const [products, setProducts] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setProducts(null);
    api.get("/products", { params: { category: category || undefined, sort } })
      .then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, [category, sort]);

  const setParam = (k, v) => {
    const next = new URLSearchParams(params);
    if (v) next.set(k, v); else next.delete(k);
    setParams(next);
  };

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24" data-testid="shop-page">
      <p className="eyebrow">Collection</p>
      <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tighter uppercase text-white mt-4" data-testid="shop-title">
        {settings?.drop_title || "THE DROP"}
      </h1>
      <div className="mt-12 mb-10 flex flex-col sm:flex-row sm:items-center justify-between gap-6 border-y border-white/10 py-5">
        <div className="flex gap-2 overflow-x-auto -mx-1 px-1" data-testid="shop-category-filters">
          {["", ...categories].map((c) => (
            <button key={c || "all"} onClick={() => setParam("category", c)} data-testid={`shop-filter-${(c || "all").toLowerCase().replace(/\s/g, "-")}`}
              className={`whitespace-nowrap text-[11px] tracking-[0.2em] uppercase px-4 py-2 border transition-colors ${category === c ? "bg-white text-black border-white" : "border-white/15 text-zinc-400 hover:text-white hover:border-white/40"}`}>
              {c || "All"}
            </button>
          ))}
        </div>
        <select value={sort} onChange={(e) => setParam("sort", e.target.value)} data-testid="shop-sort-select"
          className="bg-transparent text-[11px] tracking-[0.2em] uppercase text-zinc-300 border border-white/15 px-4 py-2 outline-none">
          <option value="newest" className="bg-black">Newest</option>
          <option value="price_asc" className="bg-black">Price: Low to high</option>
          <option value="price_desc" className="bg-black">Price: High to low</option>
        </select>
      </div>
      {products === null ? (
        <div className="h-96" />
      ) : products.length === 0 ? (
        <EmptyCatalog title={category ? "Nothing here yet." : undefined} />
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12 sm:gap-x-6" data-testid="shop-product-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
